import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { BriefcaseIcon } from 'lucide-react';
export function CorporateInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-376">
      <Header data-id="element-377" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-378">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-379"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-380">
          <div className="text-center" data-id="element-381">
            <BriefcaseIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-382" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-383">
              Corporate Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-384">
              Protecting your business interests with professional investigative
              services
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-385">
        <div className="container mx-auto px-4" data-id="element-386">
          <div className="max-w-4xl mx-auto" data-id="element-387">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-388">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-389">
                Koda Group Inc. provides comprehensive corporate investigation
                services to protect your business from internal and external
                threats. Our experienced investigators help companies uncover
                fraud, theft, misconduct, and other issues that can damage your
                organization's reputation and bottom line. We work discreetly
                and efficiently to gather evidence that can be used in legal
                proceedings or internal disciplinary actions.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-390">
                From employee misconduct investigations to intellectual property
                theft, we have the expertise and resources to handle complex
                corporate cases. Our investigators understand the sensitive
                nature of workplace investigations and maintain strict
                confidentiality throughout the process. We provide detailed
                reports and documentation that meet legal standards and can
                withstand scrutiny in court or arbitration proceedings.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-391">
                Our corporate investigation services include employee misconduct
                investigations, theft and embezzlement cases, intellectual
                property theft, due diligence investigations, background checks
                and pre-employment screening, workplace harassment and
                discrimination cases, workers' compensation fraud, vendor and
                supplier verification, and competitive intelligence gathering.
                We help businesses make informed decisions and protect their
                assets.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-392">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-393">
                Protect Your Business Today
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-394">
                Contact us for a confidential consultation about your corporate
                investigation needs.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-395">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-396" />
      <Footer data-id="element-397" />
    </div>;
}